import React from 'react';

//CORE COMPONENTS
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root/index';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { ThemeProvider } from '../../../components-core/packages/components-core/dist/theme-provider';
import styled from 'styled-components';

import {
    Container,
    ContainerGutter,
    ContainerPadding
} from '../../../components-core/packages/components-core/dist/container/index';

//3RD PARTY
import PriceArea from './PriceArea';


import { encodeHTMLEntities } from '../../helpers/encoders/Encoder';


const UnorderedList = styled.div`
    display: grid;
    grid-gap: 52px;
    grid-template-columns: repeat(3, 1fr);
    list-style: none;

    @media screen and (max-width: 960px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media screen and (max-width: 560px) {
        grid-template-columns: repeat(1, 1fr);
    }
`;


class PriceListCards extends React.Component {

    renderPriceAreas() {
        if (this.props.mode === 1) {
            const dummyData = dataListMode1(this.props);
            const newData = [];

            dummyData.forEach(dataObj => {
                if (dataObj.title) {
                    newData.push(dataObj);
                }
            })

            return newData.map(data => 
                <li style={{ float: 'left', position: 'relative' }} >
                    <PriceArea data={data} mode={this.props.mode} />
                </li>
            )
        }
    }

    render() {

        const ContainerPaddingGrid = ContainerPadding.grid002;

        return (
            <ThemeProvider>
                <Container 
                    padding={{
                        left: {
                            [Breakpoints.b560]: ContainerPaddingGrid,                            
                        },
                        right: {
                            [Breakpoints.b560]: ContainerPaddingGrid,                            
                        }
                    }}
                >
                    <UnorderedList>
                        {this.renderPriceAreas()}
                    </UnorderedList>
                </Container>
            </ThemeProvider>
        )
    }
}

export default PriceListCards;


const dataListMode1 = (props) => [
    {
        'title': encodeHTMLEntities(props.custom),
        'price': '₺ ' + encodeHTMLEntities(props.custom12),
        'image': props.custom6,
        'backgroundColor': encodeHTMLEntities(props.custom18),
        'modelLink':props.custom24
    },
    {
        'title': encodeHTMLEntities(props.custom1),
        'price': '₺ ' + encodeHTMLEntities(props.custom13),
        'image': props.custom7,
        'backgroundColor': encodeHTMLEntities(props.custom19),
        'modelLink':props.custom25
    },
    {
        'title': encodeHTMLEntities(props.custom2),
        'price': '₺ ' + encodeHTMLEntities(props.custom14),
        'image': props.custom8,
        'backgroundColor': encodeHTMLEntities(props.custom20),
        'modelLink':props.custom26
    },
    {
        'title': encodeHTMLEntities(props.custom3),
        'price': '₺ ' + encodeHTMLEntities(props.custom15),
        'image': props.custom9,
        'backgroundColor': encodeHTMLEntities(props.custom21),
        'modelLink':props.custom27
    },
    {
        'title': encodeHTMLEntities(props.custom4),
        'price': '₺ ' + encodeHTMLEntities(props.custom16),
        'image': props.custom10,
        'backgroundColor': encodeHTMLEntities(props.custom22),
        'modelLink':props.custom28
    },
    {
        'title': encodeHTMLEntities(props.custom5),
        'price': '₺ ' + encodeHTMLEntities(props.custom17),
        'image': props.custom11,
        'backgroundColor': encodeHTMLEntities(props.custom23),
        'modelLink':props.custom29
    }
]
